import { useState, useEffect } from 'react';

const getMapStateFromUrl = (search) => {
    const params = new URLSearchParams(search);
    const lat = parseFloat(params.get('lat'));
    const lng = parseFloat(params.get('lng'));
    const zoom = parseFloat(params.get('zoom'));

    if (!isNaN(lat) && !isNaN(lng) && !isNaN(zoom)) {
        return { center: { lat, lng }, zoom: zoom };
    }
    return null;
};

const getMapStateFromStorage = () => {
    try {
        const savedState = localStorage.getItem('lastMapLocation');
        if (savedState) {
            return JSON.parse(savedState);
        }
    } catch (e) {
        console.error("Failed to parse map state from localStorage", e);
    }
    return null;
};

const getMapStateFromIp = async () => {
    try {
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) throw new Error('IP API request failed');
        const data = await response.json();
        if (data.latitude && data.longitude) {
            return {
                center: { lat: data.latitude, lng: data.longitude },
                zoom: 10,
            };
        }
    } catch (error) {
        console.error("Failed to fetch location from IP:", error);
    }
    return null;
};

export const useMapInitialState = (search, geolocation, defaultState) => {
    const [initialState, setInitialState] = useState(null);

    useEffect(() => {
        const determineInitialState = async () => {
            const urlState = getMapStateFromUrl(search);
            if (urlState) {
                setInitialState(urlState);
                return;
            }

            if (geolocation.latitude && geolocation.longitude) {
                const geoState = {
                    center: { lat: geolocation.latitude, lng: geolocation.longitude },
                    zoom: 12,
                };
                setInitialState(geoState);
                return;
            }

            const storedState = getMapStateFromStorage();
            if (storedState) {
                setInitialState(storedState);
                return;
            }

            const ipState = await getMapStateFromIp();
            if (ipState) {
                setInitialState(ipState);
                return;
            }
            
            setInitialState(defaultState);
        };

        determineInitialState();
    }, [search, geolocation.latitude, geolocation.longitude, defaultState]);

    return initialState;
};